module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-4-906df6da1efef926a997747c2bbb3a68.jpg";